import App from 'app/app.js';

function LtBillingFieldMessagesDirective() {
  return {
    restrict: 'E',
    scope: {
      inValid: '=',
      maxLengthInvalid: '=',
      stateProvince: '=',
      addressRestriction: '='
    },
    template:
      '<div ng-show="addressRestriction" class="address-restrict-message">' +
      '<span lt-translate="BILLING_INFO_ADDRESS_RESTRICTION_MESSAGE" ' +
      'lt-translate-values="{state: stateProvince}"></span>' +
      '</div>' +
      '<div ng-show="inValid">' +
      '    <label lt-translate="FIELD_REQUIRED_ERROR" class="error-text"></label>' +
      '</div>' +
      '<div ng-show="maxLengthInvalid">' +
      '    <label lt-translate="ADDRESS_CITY_MAX_LENGTH" class="error-text"></label>' +
      '</div>'
  };
}

App.directive('ltBillingFieldMessages', [LtBillingFieldMessagesDirective]);
